Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spotify = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Spotify = function Spotify(_ref) {
  var spotifyLink = _ref.spotifyLink,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 320 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 380 : _ref$height;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": "spotify",
    title: "spotify-".concat(spotifyLink),
    className: "spotify-mdx-embed",
    src: "https://open.spotify.com/embed/".concat(spotifyLink),
    width: width,
    height: height,
    frameBorder: "0",
    allow: "encrypted-media"
  }));
};
exports.Spotify = Spotify;